<template>
  <div class="give-friends">
        <!-- 支付失败 -->
    <!-- <app-header></app-header> -->
    <div class="fail" v-if="paymentRes === 'fail'">
      <p class="msg text-center">Your payment is failed</p>
      <div class="btn">
        <van-button type="info" size="large" round @click="onPayTap">Pay Again</van-button>
        <!-- <p class="back text-center blue" @click="goHome">Back To Home Page</p> -->
      </div>
    </div>
    <!-- 支付成功 -->
    <div class="success" v-else>
      <img class="card-img" v-if="cardFace" :src="cardFace"  @click="changeCardTap">
      <div class="choose-card text-center blue" v-else @click="changeCardTap">Choose Your Card Face</div>
      <div class="text-center card-msg tit-gray" v-if="pageData.voucherNumber">
        Including <span>{{pageData.voucherNumber}}</span> <span> {{pageData.voucherNumber === '1' ? 'Coupon' : 'Coupons'}}</span>, Total Payment Amount:{{pageData.currency | unitFormat}}{{pageData.totalAmount}}
        <!-- 礼品卡1张，包含<span>{{pageData.goodsList.length}}</span>个商品，{{pageData.currency | unitFormat}}{{pageData.totalAmount}} -->
      </div>
      <div class="article">
        <!-- maxlength="50"
         show-word-limit -->
        <van-field
          v-model="transferParams.description"
          rows="4"
          autosize
          type="textarea"
          placeholder="Enter your blessings"
          @input="upDateRemark"
          maxlength="200"
          show-word-limit
        />
      </div>
      <div class="btn">
        <!-- :disabled="!cardFace" -->
        <van-button type="info" size="large" :disabled="isGive" round @click="SendTap">GIFT IT</van-button>
        <van-button v-if="!transferParams.voucherId" :disabled="isGive" class="btn-line blue" type="info" size="small" round @click="onSelfTap">Keep to Myself</van-button>
      </div>
      <div class="footer blue fx fx-center" v-show="showFooter">
        <p @click="goPage('myGiftCard')">Check My Gift Status </p>
        <span>|</span>
        <p @click="goPage('home')">Send Another Gift</p>
      </div>
    </div>
    <!-- 分享模块 -->
    <van-action-sheet v-model="shareSheet" title="GIFT IT" id="cnt">
      <div class="share-content fx">
        <div class="item" @click="shareItemTap('other')">
          <img src="@/assets/img/copy.png" />
          <p class="text-center" style="width: 80px">Copy Gift URL to Share</p>
        </div>
        <div class="item" @click="shareItemTap('wa')">
          <img src="@/assets/img/whatsApp.png" />
          <p class="text-center" style="width: 80px">WhatsApp</p>
        </div>
        <div class="item" @click="shareItemTap('fb')">
          <img src="@/assets/img/facebook.png" />
          <p class="text-center" style="width: 80px">Facebook</p>
        </div>
      </div>
      <div class="share-tips gray">
         Please retry or use other way to share if your Facebook or Whatsapp is not opened
      </div>
    </van-action-sheet>

    <!-- 分享分类提示-->
    <van-dialog v-model="tipsDialog"
                :showCancelButton="true"
                :closeOnClickOverlay="false"
                @confirm="hintConfirm"
                @cancel="hintCancel"
                confirm-button-text="OK"
                cancel-button-text="Don't Remind Me Again"
                :close-on-click-overlay="true"
                :close-on-popstate="true">
      <div class="tips-content">
        <div class="txt" v-if="shareType === 'wa'">
          <p>To Share From Whatsapp, Please Enable the "Block Pop-ups" in Browser Settings.  </p>
        </div>
        <div class="txt" v-if="shareType === 'fb'">
          <p>To Share the Gift to a Facebook Friend, Please Use the "Private Message" instead of "Share to Facebook".</p>
        </div>
      </div>
    </van-dialog>

    <!-- 复制短链 -->
    <van-dialog v-model="copyDialog" :closeOnClickOverlay="false" :showConfirmButton="false" :close-on-click-overlay="true" :close-on-popstate="true">
      <div class="tips-content">
        <div class="txt">
          <p class="copy">Below url of your gift has been copied, please paste to SMS, Email, Wechat, Line or other channel to share.</p>
          <div class="url-link gray">{{copyShareLink || '--'}}</div>
        </div>
        <van-button
            style="width: 100%; margin-top: 20px"
            type="info" round
            data-clipboard-action="copy"
            class="item copytext"
            :data-clipboard-text="`Here's a present for you! ` + copyShareLink"
            @click="onCopy"
        >Copy it</van-button>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      copyDialog: false,
      shareSheet: false,
      tipsDialog: false,
      getOrderParams: {
        orderId: '',
        token: ''
      },
      pageData: {},
      cardFace: '',
      transferParams: {
        orderId: '',
        voucherId: '',
        packageImage: '',
        description: '',
        token: '',
        shortLink: '',
        memberId: ''
      },
      goodsNum: 0,
      paymentRes: '',
      timer: null,
      phoneType: '',
      shareType: '',
      fbHint: null, // 显示facebook分享提示
      waHint: null, // 显示wathsapp提示
      copyShareLink: '',
      showFooter: false,
      isGive: false,
      changeRemark: '',
      packageId: ''
    }
  },
  created () {
    this.fbHint = this.$util.storageGet('local', 'fbHint') || null
    this.waHint = this.$util.storageGet('local', 'waHint') || null
    let userAgent = navigator.userAgent
    this.phoneType = userAgent.includes('Mac OS') ? 'iphone' : 'android'
    const queryParams = this.$route.query

    let token = this.$util.storageGet('local', 'token')
    this.getOrderParams.token = token
    this.getOrderParams.orderId = queryParams.orderId

    this.transferParams.token = token
    this.transferParams.orderId = queryParams.orderId

    this.paymentRes = queryParams.status
    this.cardFace = this.$util.storageGet('session', 'giftImg') || ''
    this.transferParams.packageImage = this.cardFace
    if (queryParams.voucherId) {
      this.transferParams.description = this.$util.storageGet('session', 'giftDesc') || ''
      this.transferParams.voucherId = queryParams.voucherId
      this.transferParams.memberId = queryParams.memberId
      this.pageData = {
        voucherNumber: '1',
        currency: queryParams.currency,
        totalAmount: queryParams.price
      }
    } else {
      this.loadData()
    }
    this.changeRemark = this.$util.storageGet('session', 'giftDesc') ? 'true' : 'false'
  },
  beforeDestroy () { // 组件销毁前调用
    clearTimeout(this.timer)
  },
  mounted () {
  },
  methods: {
    // 获取订单详情
    getOrderInfoById (params) {
      return this.$http.post('/olvp/getOrderInfoById', 'getOrderInfoById', params, false, false)
    },
    // 转短链
    getShortLink (params) {
      return this.$http.post('/olvp/getShortLink', 'getShortLink', params, true, false)
    },
    // 新转赠接口
    newVoucherTransfer (params) {
      return this.$http.post('/olvp/newVoucherTransfer', 'newVoucherTransfer', params, false, false)
    },
    // 送自己
    transferToMySelf (params) {
      return this.$http.post('/olvp/transferToMySelf', 'transferToMySelf', params, true, false)
    },
    // 更新包裹
    updateTransferPackage (params) {
      return this.$http.post('/olvp/updateTransferPackage', 'updateTransferPackage', params, false, false, false, false)
    },
    loadData () {
      this.getOrderInfoById(this.getOrderParams).then((d) => {
        if (d.success) {
          this.pageData = d.content
          this.cardFace = this.transferParams.packageImage || this.pageData.orderUrlImage
          this.transferParams.memberId = this.pageData.memberId
          this.transferParams.packageImage = this.cardFace
          if (this.$util.storageGet('session', 'giftDesc')) {
            this.transferParams.description = this.$util.storageGet('session', 'giftDesc')
          } else {
            this.transferParams.description = this.pageData.orderRemarks || ''
          }
          this.pageData.goodsList.map((v) => {
            this.goodsNum += v.goodsNum
          })
          const hideTost = this.$util.storageGet('session', 'hideToast') || false
          if (this.$route.query.from === 'pay' && hideTost === 'false') {
            this.$cux.loadend().then(() => {
              this.$cux.toast({
                message: 'Payment is successful.',
                type: 'success'
              })
            })
          }
        }
      })
    },
    // 选择贺卡
    changeCardTap () {
      this.$router.push(`/changeCardFace?changeRemark=${this.changeRemark}`)
    },
    // 重新支付
    onPayTap () {
      this.$router.replace(`/orderDetail?type=pay&orderId=${this.transferParams.orderId}`)
    },
    goHome () {
      this.$router.replace('/home')
    },
    // 更新描祝福语
    upDateRemark (e) {
      this.changeRemark = 'true'
      this.$util.storageSet('session', 'giftDesc', e)
    },
    // 赠送流程 先更新订单 后赠送
    // 送朋友
    SendTap () {
      this.showFooter = true
      this.shareSheet = true
      // 调用转赠 生成包裹
      if (!this.cardFace) {
        this.cardFace = 'https://ebuyimg.e-mallchina.com/olvp/autocard.png'
      }
      if (!this.transferParams.description) {
        this.transferParams.description = 'Send You A Wish with Gift'
      }
    },
    // 点击分享类型 判断本地缓存 是否跳过提示
    shareItemTap (type) {
      this.shareType = type
      this.transferParams.packageImage = this.cardFace
      this.$util.storageDel('session', 'giftImg')
      this.$util.storageDel('session', 'giftDesc')
      this.newVoucherTransfer(this.transferParams).then((d) => {
        if (d.success) {
          this.packageId = d.content.packageId
          this.getshortLink().then((l) => {
            this.shareSheet = false
            this.upDate()
            if (type === 'fb') {
              const fbId = this.$util.storageGet('local', 'facebookId')
              if (!fbId) {
                const platform = this.$util.storageGet('local', 'platform')
                this.$router.push(`/thirdAuth?platformName=${platform}&backPath=${encodeURIComponent(this.$route.fullPath)}`)
              } else {
                if (this.fbHint) {
                  this.shareSheet = false
                  /* eslint-disable no-undef */
                  FB.ui({
                    method: 'share',
                    href: this.copyShareLink
                  }, function (response) {})
                } else {
                  this.shareSheet = false
                  this.tipsDialog = true
                }
              }
            } else if (type === 'wa') {
              if (this.waHint) {
                this.shareSheet = false
                window.location.href = 'whatsapp://send?text=' + `Here's a present for you! ` + encodeURIComponent(this.copyShareLink)
              } else {
                this.shareSheet = false
                this.tipsDialog = true
              }
            } else if (type === 'other') {
              setTimeout(() => {
                this.copyDialog = true
              }, 0)
            }
          })
        }
      })
    },
    onCopy () {
      let that = this
      let clipboard = new this.$clipboard('.copytext')
      clipboard.on('success', () => {
        that.$router.replace(`/myGiftCard?active=sent`)
      })
      clipboard.on('error', () => {
        // console.log('复制失败')
      })
    },
    upDate () {
      const params = {
        token: this.transferParams.token,
        packageId: this.packageId,
        shortLink: this.copyShareLink
      }
      this.updateTransferPackage(params).then((d) => {
        if (d.success) {

        }
      })
    },
    // 分享弹窗 点击确认
    hintConfirm () {
      if (this.shareType === 'wa') {
        this.$router.replace(`/home`)
        window.location.href = 'whatsapp://send?text=' + `Here's a present for you! ` + encodeURIComponent(this.copyShareLink)
      } else if (this.shareType === 'fb') {
        /* eslint-disable no-undef */
        this.$router.replace(`/home`)
        FB.ui({
          method: 'share',
          href: this.copyShareLink
        }, function (response) {})
      }
    },
    // 分享弹窗  不再提示按钮
    hintCancel () {
      if (this.shareType === 'fb') {
        this.$util.storageSet('local', 'fbHint', true)
        this.fbHint = true
      } else if (this.shareType === 'wa') {
        this.$util.storageSet('local', 'waHint', true)
        this.waHint = true
      }
      // 调用分享
      this.hintConfirm()
    },
    // 获取分享短链
    getshortLink () {
      const name = this.$util.storageGet('local', 'name') || ''
      const picture = this.$util.storageGet('local', 'picture') || 'https://ebuyimg.e-mallchina.com/olvp/logo.png'
      let params = {
        longLink: window.location.href.split('#')[0] + '#/receiveGift?memberId=' + this.transferParams.memberId + '&packageId=' + this.packageId + '&orderId=' + this.$route.query.orderId + '&name=' + encodeURIComponent(name) + '&picture=' + encodeURIComponent(picture)
      }
      return new Promise(resolve => {
        this.getShortLink(params).then((d) => {
          if (d.content.shortLink) {
            this.copyShareLink = d.content.shortLink
          } else {
            this.copyShareLink = params.longLink
          }
          this.transferParams.shortLink = this.copyShareLink
          resolve(this.copyShareLink)
        })
      })
    },
    // 送自己
    onSelfTap () {
      this.isGive = true
      if (!this.cardFace) {
        this.cardFace = 'https://ebuyimg.e-mallchina.com/olvp/autocard.png'
      }
      if (!this.transferParams.description) {
        this.transferParams.description = 'Send You A Wish with Gift'
      }
      this.transferParams.packageImage = this.cardFace
      this.transferToMySelf(this.transferParams).then((d) => {
        if (d.success) {
          this.$cux.toast({
            message: 'The gift coupon has been put into your Ugift wallet.',
            type: 'success'
          })
          this.$util.storageDel('session', 'giftImg')
          this.$util.storageDel('session', 'giftDesc')
          this.$router.replace(`/coupons`)
        }
      })
    },
    goPage (e) {
      this.$router.replace(`/${e}`)
    }
  }
}
</script>

<style lang="scss">
  .give-friends {
    background: #f5f5f5;
    width: 100%;
    height: 100%;
    padding-top: 20px;
    position: relative;
    .footer {
      padding: 20px 0;
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      span {
        margin: 0 5px;
      }
    }
    .tips-content {
      padding: 30px 20px;
      overflow: hidden;
      .txt {
        .copy {
          line-height: 20px;
        }
        .url-link {
          padding: 10px;
          text-align: center;
          background: #f5f5f5;
          margin-top: 20px;
          border-radius: 3px;
        }
      }
    }
    .fail {
      .msg {
        margin-bottom: 60px;
        font-size: 20px;
      }
      width: 100%;
      position: absolute;
      top: 50%;
      margin-top: -30%;
    }
    .card-msg {
      padding: 0 10px;
    }
    .share-content {
      background: #fff;
      padding: 20px;
      .item {
        margin-right: 10px;
        font-size: 12px;
        img {
          width: 50px;
          height: 50px;
          margin: 0 auto;
          margin-bottom: 10px;
          border-radius: 50%;
        }
      }
    }
    .share-tips {
      border-top: 1px solid #ebedf0;
      padding: 20px;
    }
    .card-img {
      width: 70%;
      margin: 0 auto;
      margin-bottom: 15px;
      border-radius: 8px;
      box-shadow: 0px 0px 15px #dbdbdb;
    }
    .choose-card {
      width: 80%;
      margin: 0 auto;
      margin-bottom: 15px;
      background: #fff;
      height: 160px;
      line-height: 160px;
      box-shadow: 5px 5px 10px #dbdbdb;
      border-radius: 8px;
    }
    .article {
      padding: 20px 0;
      textarea {
        width: 100%;
        height: 150px;
        border: none;
        margin: 0;
        box-sizing: border-box;
      }
    }
    .btn {
      margin-top: 20px;
      width: 100%;
      padding: 0 20px;
    }
  }
</style>
